var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.49995 6.89995V6.39995V4.79995C8.49995 4.50821 8.61584 4.22842 8.82213 4.02213C9.02842 3.81584 9.30821 3.69995 9.59995 3.69995C9.89169 3.69995 10.1715 3.81584 10.3778 4.02213C10.5841 4.22842 10.7 4.50821 10.7 4.79995V6.39995V6.89995H11.2H20.7999H21.2999V6.39995V4.79995C21.2999 4.50821 21.4158 4.22842 21.6221 4.02213C21.8284 3.81584 22.1082 3.69995 22.4 3.69995C22.6917 3.69995 22.9715 3.81584 23.1778 4.02213C23.3841 4.22842 23.5 4.50821 23.5 4.79995V6.39995V6.89995H24H25.5999C26.316 6.89995 27.0028 7.18441 27.5091 7.69076C28.0155 8.19711 28.2999 8.88387 28.2999 9.59995V25.5999C28.2999 26.316 28.0155 27.0028 27.5091 27.5091C27.0028 28.0155 26.316 28.2999 25.5999 28.2999H6.39995C5.68387 28.2999 4.99711 28.0155 4.49076 27.5091C3.98441 27.0028 3.69995 26.316 3.69995 25.5999V9.59995C3.69995 8.88387 3.98441 8.19711 4.49076 7.69076C4.99711 7.18441 5.68387 6.89995 6.39995 6.89995H7.99995H8.49995ZM9.59995 10.7C9.043 10.7 8.50885 10.9212 8.11503 11.315C7.7212 11.7089 7.49995 12.243 7.49995 12.8C7.49995 13.3569 7.7212 13.891 8.11503 14.2849C8.50885 14.6787 9.043 14.9 9.59995 14.9H22.4C22.9569 14.9 23.491 14.6787 23.8849 14.2849C24.2787 13.891 24.5 13.3569 24.5 12.8C24.5 12.243 24.2787 11.7089 23.8849 11.315C23.491 10.9212 22.9569 10.7 22.4 10.7H9.59995Z",
    fill: "#8F03ED",
    stroke: "#8F03ED"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.c9005ffe8b951ba3d8ac1d4fdc45d7a4.svg";
export { ForwardRef as ReactComponent };